import http, {setAuthToken} from "./httpService.ts";
import {ILoginResponse} from "../models/interfaces/loginResponse.interface.ts";


// Login with email and password
export const login = async (username: string, password: string): Promise<ILoginResponse> => {
  try {
    const credentials = btoa(`${username}:${password}`);
    const response = await http.post("/api/v1/users/auth/login", null, {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });

    // Save JWT token to localStorage
    const loginResponse: ILoginResponse = response.data as ILoginResponse;
    const token: string = loginResponse.jwt;
    localStorage.setItem("authToken", token);

    // Set the token for future requests
    setAuthToken(token);

    return loginResponse;
  } catch (err) {
    console.error("Login failed:", err);
    throw err;
  }
};

// Google login function
export const loginWithGoogle = async (): Promise<ILoginResponse> => {
  const response = await http.post("/api/v1/users/auth/login/google");

  const token = response.data.jwt;
  localStorage.setItem("authToken", token);
  setAuthToken(token);

  return response.data;
};

// Refresh token function
export const refreshToken = async (): Promise<ILoginResponse> => {
  const response = await http.put("/api/v1/users/auth/me/refresh-token");
  const token = response.data.jwt;
  localStorage.setItem("authToken", token);
  setAuthToken(token);

  return response.data;
};

// Logout function
export const logout = () => {
  localStorage.removeItem("authToken");
  setAuthToken(null);
};

// Get token from localStorage
export const getAuthToken = () => {
  return localStorage.getItem("authToken");
};
